import {createContext, useContext} from 'react';

export type NavbarVariant = 'accent';
export type NavbarContextValue = {
  variant?: NavbarVariant;
};

const NavbarContext = createContext<NavbarContextValue>({});

export const NavbarProvider = NavbarContext.Provider;

export const useNavbarContext = () => {
  return useContext(NavbarContext);
};
